function About() {
  return (
    <section className="section about-section">
      <div className="container">
        <div className="about-content">
          <p>
          Mako currently leads extended reality design tools and 3D applications at Zoox, 
          a fully autonomous robotaxi company. Previously, he worked at the National Aeronautics and 
          Space Administration for the Center for Design and Space Architecture. He has a track record 
          for leading successful design/development initiatives - including the largest exhibition ever 
          shown at the Harvard Art Museums. Mako graduated from the Rhode Island School of Design.
          His interests include spatial computing, public transportation, indigenous Japanese art, 
          and working with people he admires.
          </p>
          <p>Feel free to reach out!</p>
        </div>
      </div>
    </section>
  )
}

export default About

